<router-outlet></router-outlet>
<app-pathways-confirm-dialog />
<app-account-settings-dialog />
<app-staticrypt-passphrase-dialog />
<app-pi-send-options-dialog />
<!-- PAT-203 — maintenance mode: announce banner, lock overlay, post-release what's new -->
<app-maintenance-banner />
<app-maintenance-overlay />
<app-whats-new-modal />
<!-- PAT-354 — Send feedback dialog (account menu) -->
<app-feedback-dialog />
@if (userMenuNavLoading.active()) {
  <div class="user-menu-nav-loading" role="status" aria-live="polite" aria-busy="true">
    <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
    <span>{{ userMenuNavLoading.message() }}</span>
  </div>
}
